import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import useComposerStore from '../../../configurator-composer/composer/composerStore';
import ComposerPreview from '../composerPreview';
import { ComposerEmptyState, ComposerEyebrow, ComposerPanel, ComposerPanelHeader, ComposerPanelTitle } from '../composerWorkspace';
import { ComposerDesignEditor } from './composerDesignEditor';
import { ComposerTemplateEditor } from './composerTemplateEditor';

const ComposerTemplatesContent = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    grid-template-columns: minmax(220px, var(--c2, 2fr)) minmax(280px, var(--c3, 3fr)) minmax(320px, var(--c4, 3fr));
    overflow: hidden;
`;

const EmptyTemplatePanel: React.FC<{ title: string }> = ({ title }) => (
    <ComposerPanel>
        <ComposerPanelHeader>
            <ComposerPanelTitle>
                <ComposerEyebrow>{title}</ComposerEyebrow>
            </ComposerPanelTitle>
        </ComposerPanelHeader>
        <ComposerEmptyState>{T._('Select one template and one area to work here.', 'Admin')}</ComposerEmptyState>
    </ComposerPanel>
);

export const ComposerTemplateContentPage: React.FC = () => {
    const [selectedTemplates, selectedAreas, designs, getDesign] = useComposerStore((state) => [
        state.selectedTemplates,
        state.selectedAreas,
        state.designs,
        state.getDesign
    ]);
    const design = getDesign(
        selectedTemplates && selectedTemplates.length === 1 ? selectedTemplates[0].templateID : -1,
        selectedAreas && selectedAreas.length === 1 ? selectedAreas[0].sideID : -1
    );
    const hasSelection = selectedTemplates?.length === 1 && selectedAreas?.length === 1 && !!design;
    return (
        <ComposerTemplatesContent>
            {hasSelection ? (
                <ComposerTemplateEditor template={selectedTemplates![0]} area={selectedAreas![0]} />
            ) : (
                <EmptyTemplatePanel title={T._('Template settings', 'Admin')} />
            )}
            {hasSelection ? (
                <ComposerDesignEditor template={selectedTemplates![0]} area={selectedAreas![0]} design={design!} />
            ) : (
                <EmptyTemplatePanel title={T._('Design editor', 'Admin')} />
            )}
            <ComposerPreview />
        </ComposerTemplatesContent>
    );
};
